/**
 * Veri kaynagi:
 * - REACT_APP_USE_API_DATA=true  -> tum resource'lar NestJS API (Firebase yok)
 * - REACT_APP_USE_API_DATA=false -> legacy Firebase (geri alma)
 */
import apiDataProvider from './apiDataProvider';

const useApiData = process.env.REACT_APP_USE_API_DATA === 'true';

let dataProvider = apiDataProvider;

if (!useApiData) {
  const { FirebaseDataProvider } = require('react-admin-firebase');
  const { FirebaseConfig, FirebaseOptions } = require('../config/firebase');
  dataProvider = FirebaseDataProvider(FirebaseConfig, FirebaseOptions);
}

export default dataProvider;
